<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h5 class="content-header-title float-left pr-1 mb-0" v-if="proposal.property && proposal.property.address">{{ proposal.property.address.street }}, {{ countryName(proposal.country) }}</h5>
            <h5 class="content-header-title float-left pr-1 mb-0" v-else>-</h5>
            <div class="breadcrumb-wrapper col-12">
              <ol class="breadcrumb p-0 mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'DashboardPage' }">
                    <em class="bx bx-home-alt"></em>
                  </router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'ContractProposalsPage' }">{{$t('Contract Proposals')}}</router-link>
                </li>
                <li class="breadcrumb-item active" v-if="proposal.property && proposal.property.address">{{ proposal.property.address.street }}, {{ countryName(proposal.country) }}</li>
                <li class="breadcrumb-item active" v-else>-</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
      <div class="row match-height">
        <div class="col-12">
          <div class="text-right">
            <router-link :to="{name: 'ContractProposalsPage' }">
              <button class="btn btn-secondary mb-1">
                {{$t('Go back to list')}}
              </button>
            </router-link>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <h2 :class="(!proposal.negotiationStatus && proposal.creationStatus != 'approved') ? 'mb-2' : ''" v-if="proposal.property && proposal.property.address">{{ proposal.property.address.street }}, {{ countryName(proposal.country) }}</h2>
                    <h2 :class="(!proposal.negotiationStatus && proposal.creationStatus != 'approved') ? 'mb-2' : ''" v-else>-</h2>
                    <div
                      style="float: left"
                      v-if="!proposal.negotiationStatus && proposal.creationStatus != 'approved'"
                    >
                      <router-link :to="{name: 'EditContractProposalPage', params: {uid: proposal.id} }">
                        <button class="btn btn-secondary">{{$t('Edit Proposal')}}</button>
                      </router-link>
                    </div>
                    <span v-if="!proposal.negotiationStatus && proposal.creationStatus != 'approved'">
                      <br>
                      <br>
                      <br>
                    </span>
                    <small
                      v-if="proposal.createdAt"
                      style="white-space: nowrap;"
                    >
                      {{$t('Created on')}} {{ proposal.createdAt.split("T")[0] }} - ID: {{ proposal.id }}
                    </small>
                    <br />
                    {{$t('Creation Status')}}:
                    <div
                      class="badge badge-secondary mr-1 mb-1 mt-1"
                      v-if="proposal.creationStatus == 'draft_by_admin'"
                    >{{ proposal.creationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-secondary mr-1 mb-1 mt-1"
                      v-if="proposal.creationStatus == 'draft_by_landlord'"
                    >{{ proposal.creationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-info mr-1 mb-1 mt-1"
                      v-if="proposal.creationStatus == 'needs_approval_by_admin'"
                    >{{ proposal.creationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-info mr-1 mb-1 mt-1"
                      v-if="proposal.creationStatus == 'needs_approval_by_landlord'"
                    >{{ proposal.creationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-success mr-1 mb-1 mt-1"
                      v-if="proposal.creationStatus == 'approved'"
                    >{{ proposal.creationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-warning mr-1 mb-1 mt-1"
                      v-if="proposal.creationStatus == 'archived'"
                    >{{ proposal.creationStatus.replaceAll("_", " ").toUpperCase() }}</div>

                    <span v-if="proposal.negotiationStatus">{{$t('Negotiation Status')}}: </span>
                    <div
                      class="badge badge-success mr-1 mb-1 mt-1"
                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'accepted_by_landlord'"
                    >{{ proposal.negotiationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-success mr-1 mb-1 mt-1"
                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'accepted_by_all'"
                    >{{ proposal.negotiationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-danger mr-1 mb-1 mt-1"
                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'declined_by_tenant'"
                    >{{ proposal.negotiationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-info mr-1 mb-1 mt-1"
                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'change_requested_by_tenant'"
                    >{{ proposal.negotiationStatus.replaceAll("_", " ").toUpperCase() }}</div>
                    <div
                      class="badge badge-warning mr-1 mb-1 mt-1"
                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'archived'"
                    >{{ proposal.negotiationStatus.replaceAll("_", " ").toUpperCase() }}</div>

                    <select class="form-control" style="width: 150px;" disabled>
                      <option selected disabled>{{ countryName(proposal.country) }}</option>
                    </select>
                    <div v-if="creationStatusDescription.trim() != ''">
                      <br>
                      <label for="">{{$t('Creation status description')}}</label>
                      <input type="text" class="form-control" disabled v-model="creationStatusDescription">
                    </div>
                    <div v-if="negotiationStatusDescription.trim() != ''">
                      <br>
                      <label for="">{{$t('Negotiation status description')}}</label>
                      <input type="text" class="form-control" disabled v-model="negotiationStatusDescription">
                    </div>
                    <hr />
                    <h4 class="mt-2">{{$t('Users')}}</h4>
                    <ul class="list-group list-group-flush">
                      <li
                        class="list-group-item list-group-item-action border-0 d-flex align-items-center justify-content-between pl-0"
                        v-if="proposal.landlord"
                      >
                        <div class="list-left d-flex">
                          <div class="list-icon mr-1">
                            <div class="avatar bg-rgba-warning m-0 p-25">
                              <div class="avatar-content">
                                <span class="font-medium-1 text-warning">L</span>
                              </div>
                            </div>
                          </div>
                          <div class="list-content">
                            <span
                              class="list-title"
                              v-if="proposal.landlord.user"
                            >{{ (proposal.landlord.user.name) ? proposal.landlord.user.name : '-' }} ({{ (proposal.landlord.user.email) ? proposal.landlord.user.email : '-' }} / {{ (proposal.landlord.user.phoneNumber) ? proposal.landlord.user.phoneNumber : '-' }})</span>
                            <span
                              class="list-title"
                              v-else
                            >{{ (proposal.landlord.invite.name) ? proposal.landlord.invite.name : '-' }} ({{ (proposal.landlord.invite.email) ? proposal.landlord.invite.email : '-' }} / {{ (proposal.landlord.invite.phoneNumber) ? proposal.landlord.invite.phoneNumber : '-' }})</span>
                            <small class="text-muted d-block">
                              {{ (proposal.landlord.user) ? 'User' : 'Invited' }} -
                              <router-link
                                :to="{name: 'SingleUserPage', params: {uuid: proposal.landlord.user.uid} }"
                                v-if="proposal.landlord.user"
                              >{{$t('View Details')}}</router-link>
                            </small>
                          </div>
                        </div>
                      </li>
                      <li
                        class="list-group-item list-group-item-action border-0 d-flex align-items-center justify-content-between pl-0"
                        v-if="proposal.tenants"
                      >
                        <div class="list-left d-flex">
                          <div class="list-icon mr-1">
                            <div class="avatar bg-rgba-warning m-0 p-25">
                              <div class="avatar-content">
                                <span class="font-medium-1 text-warning">T</span>
                              </div>
                            </div>
                          </div>
                          <div class="list-content">
                            <span
                              class="list-title"
                              v-if="proposal.tenants[0].user"
                            >{{ (proposal.tenants[0].user.name) ? proposal.tenants[0].user.name : '-' }} ({{ (proposal.tenants[0].user.email) ? proposal.tenants[0].user.email : '-' }} / {{ (proposal.tenants[0].user.phoneNumber) ? proposal.tenants[0].user.phoneNumber : '-' }})</span>
                            <span
                              class="list-title"
                              v-else
                            >{{ (proposal.tenants[0].invite.name) ? proposal.tenants[0].invite.name : '-' }} ({{ (proposal.tenants[0].invite.email) ? proposal.tenants[0].invite.email : '-' }} / {{ (proposal.tenants[0].invite.phoneNumber) ? proposal.tenants[0].invite.phoneNumber : '-' }})</span>
                            <small class="text-muted d-block">
                              {{ (proposal.tenants[0].user) ? 'User' : 'Invited' }} -
                              <router-link
                                :to="{name: 'SingleUserPage', params: {uuid: proposal.tenants[0].user.uid} }"
                                v-if="proposal.tenants[0].user"
                              >{{$t('View Details')}}</router-link>
                            </small>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <!-- Property Informations -->
                  <div class="col-md-9 col-sm-12">
                    <hr />
                    <h4 class="mt-2">Property Informations <router-link :to="{name: 'EditHousePage', params: {uid: proposal.property.uid} }" v-if="proposal.property" style="font-size: .6em; margin-left: 6px;">View Details</router-link></h4>
                    <div v-if="proposal.property" class="mt-2">
                      <div class="row">
                        <div class="col-md-12 col-sm-12">
                          <div class="row">
                            <div class="col-md-6 col-sm-12">
                              <label for>{{$t('Name')}}</label>
                              <input
                                type="text"
                                class="form-control"
                                disabled
                                :value="proposal.property.name"
                              />
                            </div>
                            <div class="col-md-6 col-sm-12">
                              <label for>{{$t('Country')}}</label>
                              <select class="form-control" disabled>
                                <option selected>{{ countryName(proposal.property.country) }}</option>
                              </select>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-md-5 col-12">
                              <div>
                              <label for>{{$t('City')}}</label>
                                <input type="text" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.city : ''" />
                              </div>
                            </div>
                            <div class="col-md-5 col-12">
                              <div>
                                <label for>{{$t('Street')}}</label>
                                <input type="text" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.street : ''" />
                              </div>
                            </div>
                            <div class="col-md-2 col-sm-12">
                              <label for>{{$t('ZIP')}}</label>
                              <input type="text" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.zip : ''" />
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-md-4 col-12">
                              <div>
                                <label for>{{$t('Building Name')}}</label>
                                <input type="text" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.buildingName : ''" />
                              </div>
                            </div>
                            <div class="col-md-4 col-12">
                              <div>
                                <label for>{{$t('Registry Number')}}</label>
                                <input type="text" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.registryNumber : ''" />
                              </div>
                            </div>
                            <div class="col-md-4 col-12">
                              <div>
                                <label for>{{$t('Additional')}}</label>
                                <input type="text" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.additional : ''" />
                              </div>
                            </div>
                          </div>

                          <div class="row mt-2">
                            <div class="col-md-12 col-sm-12">
                              <label for>{{$t('Description')}}</label>
                              <textarea cols="30" rows="10" class="form-control" disabled :value="(proposal.property.address) ? proposal.property.address.description : ''"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Contract Informations -->
                  <div class="col-md-9 col-sm-12">
                    <hr />
                    <h4 class="mt-2">{{$t('Contract Informations')}}</h4>

                    <div class="mt-2">
                      <div class="row">
                        <div class="col-md-6 col-sm-12">
                          <label for="">{{$t('Rent Start')}}</label>
                          <input type="text" class="form-control" disabled :value="(proposal.data) ? proposal.data.rentStart.split('T')[0] : ''">
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <label for="">{{$t('Contract Duration (In Months)')}}</label>
                          <input type="text" class="form-control" disabled :value="(proposal.data) ? `${proposal.data.contractDuration} months` : ''">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-6 col-sm-12">
                          <label for="">{{$t('Payment Recurrence (In Months)')}}</label>
                          <input type="text" class="form-control" disabled :value="(proposal.data) ? `${proposal.data.paymentRecurrence} months` : ''">
                        </div> 
                        <div class="col-md-6 col-sm-12">
                          <label for="">{{$t('Payment Method')}}</label>
                          <select class="select2 form-control" multiple="multiple" id="payment-method-select" disabled>
                              <option value="cash" :selected="paymentTypes.includes('cash')">{{$t('Cash')}}</option>
                              <option value="cheque" :selected="paymentTypes.includes('cheque')">{{$t('Cheque')}}</option>
                              <option value="wire_transfer" :selected="paymentTypes.includes('wire_transfer')">{{$t('Wire Transfer')}}</option>
                              <option value="mobile_transfer" :selected="paymentTypes.includes('mobile_transfer')">{{$t('Mobile Transfer')}}</option>
                              <option value="in_kind" :selected="paymentTypes.includes('in_kind')">{{$t('In Kind')}}</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <h5 class="mt-3 text-bold-500" v-if="template.uid">{{$t('Contract Template')}}</h5>

                    <div v-if="template.uid" class="mt-2">
                      <div class="row">
                        <div class="col-md-6 col-sm-12">
                          <label>{{$t('Title (EN)')}}:</label>
                          <div class="form-group">
                            <input
                              type="text"
                              :placeholder="$t('Contract Title')"
                              class="form-control"
                              :value="template.details.en.name"
                              disabled
                            />
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <label>{{$t('Title (AR)')}}:</label>
                          <div class="form-group">
                            <input
                              type="text"
                              :placeholder="$t('Contract Title')"
                              class="form-control text-right"
                              :value="template.details.ar.name"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-12">
                          <label>{{$t('Country')}}:</label>
                          <div class="form-group">
                            <select class="form-control" disabled>
                              <option selected>{{ countryName(template.country) }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <label>{{$t('Type')}}:</label>
                          <div class="form-group">
                            <select id class="form-control" disabled :value="template.type">
                              <option
                                value="Occupancy Free of Charge Lease"
                              >{{$t('Occupancy Free of Charge Lease')}}</option>
                              <option value="Standard Residential Lease">{{$t('Standard Residential Lease')}}</option>
                              <option value="Rent Reduction Lease">{{$t('Rent Reduction Lease')}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <label for>{{$t('Description (EN)')}}</label>
                          <textarea
                            cols="30"
                            rows="7"
                            class="form-control"
                            disabled
                            :value="template.details.en.description"
                          ></textarea>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <label for>{{$t('Description (AR)')}}</label>
                          <textarea
                            cols="30"
                            rows="7"
                            class="form-control text-right"
                            disabled
                            :value="template.details.ar.description"
                          ></textarea>
                        </div>
                      </div>
                      <div class="row" style="margin-top: 15px;">
                        <div class="col-md-6 col-sm-12">
                          <label>{{$t('Status')}}:</label>
                          <div class="form-group">
                            <select class="form-control" disabled :value="template.status">
                              <option value="draft">{{$t('Draft')}}</option>
                              <option value="published">{{$t('Published')}}</option>
                              <option value="archived">{{$t('Archived')}}</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="text-left my-2">
                        <h6 class="text-bold-600">{{$t('Terms and Conditions')}}</h6>
                      </div>
                      <div>
                        <div data-repeater-item v-for="(term, index) in terms" :key="index">
                          <div class="row">
                            <div class="col-6">
                              <div class="row justify-content-between">
                                <div class="col-md-8 col-sm-8 form-group">
                                  <label for>{{$t('Term Title (EN)')}}</label>
                                  <input
                                    type="text"
                                    class="form-control term-title-edit"
                                    :placeholder="$t('Enter term title')"
                                    :value="term.title"
                                    disabled
                                  />
                                </div>
                                <div class="col-md-12 col-sm-12 form-group">
                                  <label for="password">{{$t('Term Description (EN)')}}</label>
                                  <textarea
                                    cols="30"
                                    rows="5"
                                    class="form-control term-description-edit"
                                    :placeholder="$t('Enter term description...')"
                                    :value="term.description"
                                    disabled
                                  ></textarea>
                                </div>
                              </div>
                            </div>

                            <div class="col-6">
                              <div class="row justify-content-between">
                                <div class="col-md-8 col-sm-8 form-group">
                                  <label for>{{$t('Term Title (AR)')}}</label>
                                  <input
                                    type="text"
                                    class="form-control term-title-edit-ar text-right"
                                   :placeholder="$t('Enter term title')"
                                    :value="termsAr[index].title"
                                    disabled
                                  />
                                </div>
                                <div class="col-md-2 col-sm-2"></div>
                                <div class="col-md-12 col-sm-12 form-group">
                                  <label for="password">{{$t('Term Description (AR)')}}</label>
                                  <textarea
                                    cols="30"
                                    rows="5"
                                    class="form-control term-description-edit-ar text-right"
                                    :placeholder="$t('Enter term description...')"
                                    :value="termsAr[index].description"
                                    disabled
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";

export default {
  data() {
    return {
      proposal: {},
      proposalUUID: this.$route.params.uuid,
      template: {},
      terms: [],
      termsAr: [],
      creationStatusDescription: "",
      negotiationStatusDescription: "",
      paymentTypes: []
    };
  },

  methods: {
    getProposal() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.$apiCall
        .get(`/v1/contracts/proposals/${this.proposalUUID}`)
        .then((response) => {
          this.proposal = response.data;
          this.creationStatusDescription = (this.proposal.creationStatusDescription) ? this.proposal.creationStatusDescription : "";
          this.negotiationStatusDescription = (this.proposal.negotiationStatusDescription) ? this.proposal.negotiationStatusDescription : "";

          this.paymentTypes = (this.proposal.data && this.proposal.data.paymentTypes) ? this.proposal.data.paymentTypes : [];
          
          setTimeout(() => {
            $("#payment-method-select").select2({
              placeholder: "No payment method selected..."
            });
          }, 500)

          if (this.proposal.templateId) {
            this.$apiCall
              .get(`/v1/contracts/templates/${this.proposal.templateId}`)
              .then((response) => {
                this.template = response.data;
                this.terms = this.template.terms.en;
                this.termsAr = this.template.terms.ar;
                $.unblockUI();
              })
              .catch((error) => {
                console.log(error);
                $.unblockUI();
              });
          } else {
            $.unblockUI();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
  },

  mounted() {
    this.getProposal();
  },
};
</script>

<style scoped>
.list-group .list-group-item-action:hover {
  background: #fff;
}
</style>
